import React from 'react'
import { motion, animate } from "motion/react"
import activityWidth from '../../../assets/images/activityWidth.jpg'
import c1 from '../../../assets/images/agenda/c1.png'
import c2 from '../../../assets/images/agenda/c2.png'
import c3 from '../../../assets/images/agenda/c3.png'
import c4 from '../../../assets/images/agenda/c4.png'
import c5 from '../../../assets/images/agenda/c5.png'
import c6 from '../../../assets/images/agenda/c6.png'
import c7 from '../../../assets/images/agenda/c7.png'
import c8 from '../../../assets/images/agenda/c8.png'
import c9 from '../../../assets/images/agenda/c9.png'
const sectionReveal = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.6, ease: 'easeOut' },
  viewport: { once: true, amount: 0.2 },
}
const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.20, // Delay between each card
    },
  },
};

const cardVariants = {
  hidden: { opacity: 0, x: -50 }, // Start hidden, shifted left
  show: {
    opacity: 1,
    x: 0,
    transition: { type: "spring", stiffness: 100, damping: 20 },
  },
};

export default function Activities() {
  return (
<motion.section
  {...sectionReveal}
  className="mt-20 pb-20 px-4 sm:px-6"
>
  <div className="max-w-6xl mx-auto">
    
    <div className="text-center mb-12">
      <p className="text-3xl font-semibold text-sky-700">
      الفعاليات المصاحبة للملتقى
      </p>
    </div>

    {/* Animated Cards Container */}
    <motion.div
      className="grid gap-6 md:grid-cols-2 lg:grid-cols-3"
      variants={containerVariants}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.3 }}
    >
      {[
        {
          image: c1,
          title: 'معرض مصاحب وتوقيع اتفاقيات',
          color: 'from-sky-500 to-sky-700',
        },
        {
          image: c2,
          title: 'جلسات حوارية وحلقات نقاش',
          color: 'from-emerald-500 to-emerald-700',
        },
        {
          image: c3,
          title: 'ورش عمل تدريبية',
          color: 'from-indigo-500 to-indigo-700',
        },
        {
          image: c6,
          title: 'إطلاق مبادرات داعمة لمسيرة التحول المؤسسي',
          color: 'from-[#28A2BD] to-sky-800',
        },
        {
          image: c5,
          title: 'قصص ملهمة: تميز وريادة',
          color: 'from-[#29A182] to-emerald-800',
        },
        {
          image: c4,
          title: 'جلسات إرشاد مهني وأكاديمي',
          color: 'from-[#486191] to-indigo-800',
        }
      ].map((item, index) => (
        <motion.div
          key={index}
          className="relative overflow-hidden rounded-3xl bg-white border border-slate-100 shadow-[0_25px_60px_-25px_rgba(15,23,42,0.35)]"
          variants={cardVariants}
          whileHover={{ scale: 1.04 }}
          transition={{ type: 'spring', stiffness: 240, damping: 18 }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-slate-50/70 via-white to-white" />
          <div className="relative p-8 flex justify-center items-center text-center flex-col gap-4">
            <img src={item.image} alt={item.title} className='w-[60px] object-cover' />
            {/* <div
              className={`flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br ${item.color} text-white shadow-lg ring-4 ring-white/60`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-7 w-7"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
              >
                <path d="M12 20h9" strokeLinecap="round" />
                <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" strokeLinecap="round" />
              </svg>
            </div> */}
            <h3 className="text-xl font-extrabold text-sky-700">{item.title}</h3>
          </div>
        </motion.div>
      ))}
    </motion.div>
  </div>
</motion.section>
  );
}